var styleDataHash = '2cdbd7a8';  
export const injectCss = (() => {
  var css = `.-hJsD,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}[dir] .Mjp7z{margin:15px 18px}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .Mjp7z{margin:var(--ricos-custom-code-block-margin,15px calc(18px + 5%))}}}@container (width < 640px){[dir] .Mjp7z{margin:var(--ricos-custom-code-block-margin,15px calc(18px + 5%))}}.JSCvZ,.lzlF5{font-family:Inconsolata,Menlo,Consolas,monospace;font-size:var(--ricos-custom-code-block-font-size,16px);line-height:var(--ricos-custom-code-block-line-height,26px);white-space:pre-wrap}[dir] .JSCvZ,[dir] .lzlF5{background-color:rgba(var(--ricos-fallback-color-tuple,0,0,0),.06);margin:var(--ricos-custom-code-block-margin,15px 18px);padding:var(--ricos-custom-code-block-padding,2px 25px)}.JSCvZ code,.lzlF5 code{font-family:Inconsolata,Menlo,Consolas,monospace;font-size:var(--ricos-custom-code-block-font-size,16px)}[dir] ._44lTg .JSCvZ,[dir] ._44lTg .lzlF5{margin:0}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "fontElementMap": "-hJsD",
  "blockStyleSpacing": "Mjp7z",
  "codeBlock": "lzlF5 Mjp7z",
  "code": "JSCvZ Mjp7z",
  "renderedInTable": "_44lTg"
};